module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/washing_machine-f64b3f7d6d42c1cec81ee774db33148b.svg";